import { Link } from 'react-router';
import { cx } from '@/ui';
import { useT } from '@/i18n';

/**
 * „Impressum · Datenschutz · AGB · Willkommensseite" — eine kleine graue Zeile,
 * die auf jeder Einstiegsseite steht (Turnierliste, Login, Anmeldeseite). Aus
 * der Seitenleiste und „Mehr" ist sie raus (Daniel, 09/2026: „wird ziemlich
 * voll dort unten"). Bewusst nicht in pages/Rechtliches.tsx: die Seite ist
 * lazy, die Zeile nicht.
 *
 * „Willkommensseite" (`#/willkommen`) ist der Rückweg zur Vorstellung der App,
 * die ein neuer Besucher unter `#/` sieht (lib/willkommen.ts) — auf der
 * Willkommensseite selbst steht der Link nicht (`willkommen={false}`).
 */
export function RechtLinks({ className, willkommen = true }: { className?: string; willkommen?: boolean }) {
  const t = useT();
  // Am Handy 44 px hoch zum Treffen — die Zeile bleibt klein und grau, nur die Fläche wächst
  const link = 'text-dim hover:text-ink no-underline max-md:inline-flex max-md:items-center max-md:min-h-11';
  const punkt = <span className="mx-1.5 opacity-60">·</span>;
  return (
    <nav className={cx('label text-[10px] tracking-[.08em]', className)} aria-label={t('Rechtliches')} data-rechtlinks>
      <Link to="/rechtliches?tab=impressum" className={link}>
        {t('Impressum')}
      </Link>
      {punkt}
      <Link to="/rechtliches?tab=datenschutz" className={link}>
        {t('Datenschutz')}
      </Link>
      {punkt}
      <Link to="/rechtliches?tab=agb" className={link}>
        {t('AGB')}
      </Link>
      {willkommen && (
        <>
          {punkt}
          <Link to="/willkommen" className={link}>
            {t('Willkommensseite')}
          </Link>
        </>
      )}
    </nav>
  );
}
